import {
  logProductListViewEvent,
  logProductSelectEvent,
  logProductViewEvent,
  logSearchaniseProductListViewEvent,
  logSearchaniseProductSelectEvent,
} from './product';

import {
  logAddProductToCartEvent,
  logRemoveProductFromCartEvent,
  logViewCartEvent,
} from './cart';

import {
  logBeginCheckoutEvent,
  logAddShippingInfoEvent,
  logAddPaymentInfoEvent,
  logPurchaseEvent,
} from './checkout';

import { logAddPersonalisedMessage, logAddPersonalisedDate } from './engraving';

export {
  // Product view, select
  logProductListViewEvent,
  logProductSelectEvent,
  logProductViewEvent,
  logSearchaniseProductListViewEvent,
  logSearchaniseProductSelectEvent,

  // Cart modification
  logAddProductToCartEvent,
  logRemoveProductFromCartEvent,
  logViewCartEvent,

  // Checkout page
  logBeginCheckoutEvent,
  logAddShippingInfoEvent,
  logAddPaymentInfoEvent,
  logPurchaseEvent,
};

export {
  logAddPersonalisedMessage,
  logAddPersonalisedDate,
};
